/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Refund_ConfirmInputs */

const en_delivery_board_refund_confirm = /** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to refund this order? This will also attempt to reverse the payment in Stripe.`)
};

const es_delivery_board_refund_confirm = /** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres reembolsar este pedido? Esto también intentará revertir el pago en Stripe.`)
};

const fr_delivery_board_refund_confirm = /** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir rembourser cette commande ? Cela tentera également d'annuler le paiement dans Stripe.`)
};

const de_delivery_board_refund_confirm = /** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher, dass du diese Bestellung erstatten möchtest? Dies wird auch versuchen, die Zahlung in Stripe zu stornieren.`)
};

const id_delivery_board_refund_confirm = /** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda yakin ingin mengembalikan dana pesanan ini? Ini juga akan mencoba membatalkan pembayaran di Stripe.`)
};

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const ja_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const zh_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const ar_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const it_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const ru_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const pt_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/** @type {(inputs: Delivery_Board_Refund_ConfirmInputs) => LocalizedString} */
const ko_delivery_board_refund_confirm = en_delivery_board_refund_confirm;

/**
* | output |
* | --- |
* | "Are you sure you want to refund this order? This will also attempt to reverse the payment in Stripe." |
*
* @param {Delivery_Board_Refund_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_refund_confirm = /** @type {((inputs?: Delivery_Board_Refund_ConfirmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Refund_ConfirmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_refund_confirm(inputs)
	if (locale === "es") return es_delivery_board_refund_confirm(inputs)
	if (locale === "fr") return fr_delivery_board_refund_confirm(inputs)
	if (locale === "de") return de_delivery_board_refund_confirm(inputs)
	if (locale === "ja") return ja_delivery_board_refund_confirm(inputs)
	if (locale === "zh") return zh_delivery_board_refund_confirm(inputs)
	if (locale === "ar") return ar_delivery_board_refund_confirm(inputs)
	if (locale === "id") return id_delivery_board_refund_confirm(inputs)
	if (locale === "it") return it_delivery_board_refund_confirm(inputs)
	if (locale === "ru") return ru_delivery_board_refund_confirm(inputs)
	if (locale === "pt") return pt_delivery_board_refund_confirm(inputs)
	return ko_delivery_board_refund_confirm(inputs)
});